import offlineProgressSync from '../src/react/helpers/OfflineProgressSync';
import { clearVpePersistedChatError } from './case_experience/vpe_chat_error_persistence';

export const getDocumentUserStateResetFromDom = () => {
  const container = document.getElementById('document-container');
  if (!container) return 0;

  const raw =
    container.getAttribute('data-case-viewer-document-user-state-reset-value') ||
    container.getAttribute('data-case-experience--case-viewer-document-user-state-reset-value');
  const parsed = parseInt(raw, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const getCaseIdsFromDom = () => {
  const container = document.getElementById('document-container');
  if (!container) return null;

  const documentId =
    container.getAttribute('data-case-viewer-document-id-value') ||
    container.getAttribute('data-case-experience--case-viewer-document-id-value');
  const userId =
    container.getAttribute('data-case-viewer-user-id-value') ||
    container.getAttribute('data-case-experience--case-viewer-user-id-value');

  if (!documentId || !userId) return null;

  return { documentId: Number(documentId), userId: Number(userId) };
};

export const getCurrentUserIdFromDom = () => {
  const raw = document.documentElement.getAttribute('data-user-id');
  const parsed = parseInt(raw, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

export const clearLocalCaseProgress = async (documentId, userId) => {
  const resolvedUserId = userId ?? getCurrentUserIdFromDom();
  const ids =
    documentId != null && resolvedUserId != null
      ? { documentId, userId: resolvedUserId }
      : getCaseIdsFromDom();
  if (!ids) return;

  clearVpePersistedChatError(ids.documentId, ids.userId);
  await offlineProgressSync.clearDocumentUserStateProgress(ids.documentId, ids.userId);
};
